class TermsConditions {
  constructor() {
    $(document).ready(() => {
      this.initialize();
    });
  }
  
  initialize() {
    this.sections = document.querySelectorAll('[data-terms-section]');
    this.pages = $('.terms-section-outer');
    this.buttons = $('[data-terms-button]');
    this.buttons.on('click', handleClick);
    this.pages.eq(0).addClass('active');
    this.observeSections();
    const observeSections = this.observeSections.bind(this);

    const pages = this.pages;
    const buttons = this.buttons;

    function handleClick() {
      const index = $(this).index();
      const inEl = pages.eq(index);
      const outEl = $('.terms-section-outer.active');
      if(inEl.hasClass('active')) return;
      console.log(index);
      
      buttons.removeClass('active')
      $(this).addClass('active');
      
      gsap.to(outEl.get(), {
        opacity: 0,
        duration: 0.6,
        onComplete: () => {
          outEl.removeClass('active');
          outEl.css('display', 'none');
          inEl.css('display', 'block');
          inEl.addClass('active');
          observeSections();

          gsap.fromTo(inEl.get(), {
            opacity: 0
          }, {
            opacity: 1,
            duration: 0.6
          })
        }
      });
    }
  }

  observeSections() {
    if(!this.sections) return;
    const itemObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
          if(entry.isIntersecting) {
            const handle = entry.target.getAttribute('data-handle');
            history.pushState(null, null, `#${handle}`);
            $('.terms-section__navigation li').removeClass('active')
            document.querySelector(`a[href="#${handle}"]`).parentElement.classList.add('active');
          }
      });
    }, {
      threshold: 0,
      rootMargin: '-50% 0% -50% 0%'
    });

    this.sections.forEach(function(section) {
      itemObserver.observe(section)
    });
  }

  onScroll(scroll) {
    const nav = $('.terms-section__navigation');
    if(!nav) return;
    if(scroll > 200) {
      nav.addClass('active')
    } else {
      nav.removeClass('active')
    }
  }
}

const terms = new TermsConditions();